import { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Full-screen image lightbox overlay.
 * Click outside the image or press the X / Escape key to close.
 */
export function ImageLightbox({ url, onClose }) {
  useEffect(() => {
    if (!url) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [url, onClose]);

  if (!url) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm animate-in fade-in duration-150"
      onClick={onClose}
      data-testid="image-lightbox-overlay"
    >
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-4 right-4 z-10 rounded-full bg-black/60 p-2 text-white hover:bg-black/80 transition-colors"
        data-testid="image-lightbox-close"
      >
        <X className="h-6 w-6" />
      </button>
      <img
        src={url}
        alt="Preview"
        className="max-h-[90vh] max-w-[90vw] rounded-lg object-contain shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="image-lightbox-img"
      />
    </div>
  );
}
